<template>
  <div class="ion-page">
    <ion-header>
      <ion-toolbar color="navbar">
        <ion-buttons slot="start">
          <ion-button @click="onCancelled">Cancel</ion-button>
        </ion-buttons>
        <ion-title>Scan Barcode</ion-title>
      </ion-toolbar>
    </ion-header>
    <ion-content padding>
      <div id="interactive" class="viewport scanner">
        <video />
        <canvas class="drawingBuffer" />
      </div>
    </ion-content>
  </div>
</template>

<script>
import Quagga from "quagga";
import Plugins from "../mixins/Plugins";
import Helpers from "../mixins/Helpers";
export default {
  name: "scan-barcode",
  mixins: [Plugins, Helpers],
  data() {
    return {
      width: 0,
      height: 0,
      readers: ["ean_reader", "upc_reader", "code_128_reader"]
    };
  },
  computed: {
    config() {
      return {
        inputStream: {
          type: "LiveStream",
          constraints: {
            width: this.width,
            height: this.height,
            facingMode: "environment",
            aspectRatio: {
              min: 1,
              max: 2
            }
          }
        },
        locator: {
          patchSize: "medium",
          halfSample: true
        },
        numOfWorkers: 2,
        frequency: 10,
        decoder: {
          readers: ["ean_reader", "upc_reader", "code_128_reader"]
        },
        locate: true
      };
    }
  },
  mounted() {
    setTimeout(() => {
      this.loadCanvas();
      this.loadScanner();
    }, 1000);
  },
  destroyed() {
    Quagga.stop();
  },
  methods: {
    loadCanvas() {
      let ratio = 0.7;
      let container = document.querySelector("#interactive");
      this.width = container.offsetWidth;
      this.height = container.offsetWidth * ratio;
    },
    loadScanner() {
      console.log("Config", JSON.stringify(this.config));
      Quagga.init(this.config, (err) => {
        if (err) {
          return console.error(err);
        }
        Quagga.start();
      });
      Quagga.onDetected(this.onDetected);
      Quagga.onProcessed(this.onProcessed);
    },
    onCancelled() {
      this.hideModal();
    },
    onDetected(result) {
      console.log("onDetected", result);
      this.showToast("Barcode detected");
      this.hideModal({
        code: result
      });
    },
    onProcessed(result) {
      if (result) {
        let drawingCtx = Quagga.canvas.ctx.overlay;
        let drawingCanvas = Quagga.canvas.dom.overlay;
        if (result.boxes) {
          drawingCtx.clearRect(0, 0, parseInt(drawingCanvas.getAttribute("width")), parseInt(drawingCanvas.getAttribute("height")));
          result.boxes
            .filter(function(box) {
              return box !== result.box;
            })
            .forEach(function(box) {
              Quagga.ImageDebug.drawPath(box, { x: 0, y: 1 }, drawingCtx, {
                color: "green",
                lineWidth: 2
              });
            });
        }
        if (result.box) {
          Quagga.ImageDebug.drawPath(result.box, { x: 0, y: 1 }, drawingCtx, {
            color: "#00F",
            lineWidth: 2
          });
        }
        if (result.codeResult && result.codeResult.code) {
          Quagga.ImageDebug.drawPath(result.line, { x: "x", y: "y" }, drawingCtx, { color: "red", lineWidth: 3 });
        }
      }
    }
  }
};
</script>

<style scoped>
.viewport {
  position: relative;
  min-width: 400px;
  height: 300px;
}
.viewport canvas,
.viewport video {
  position: absolute;
  left: 0;
  top: 0;
  right: 0;
}
</style>
